module.exports = __webpack_public_path__ + "img/25.251b70cf.png";